<script>
  import { geocoderResult, slidesTracker, data, tileData, issueChoices, zonesChoices, issues, issueData} from '../stores.js';
  import Alert from './Alert.svelte'
  import { createMap, createAssemblySenateMap, takeScreenshot } from '../map.js';
  import { onMount } from 'svelte';
  import { get } from 'svelte/store';
  import Loading from './Loading.svelte'
  import Locality from './divisions/Locality.svelte'
  import County from './divisions/County.svelte'
  import State from './divisions/State.svelte'
  import Federal from './divisions/Federal.svelte'
  import Bottom from './Bottom.svelte'; 
  import Print from './Print.svelte';
  // import Zones from './divisions/County/Zones.svelte';

  import { __,__c, t } from '../utils/i18n.js';
  import { districtNames } from '../utils/copy.js';
  import { congressionalBounds } from '../boundaries/congressional-boundaries.js';

  // $: console.log('TEST THIS -- PREVIEW', $issueData);

  let feed = $tileData;
  // console.log ('this feed comes from the tileset', feed);

  function groupBy(objectArray, property) {
   return objectArray.reduce((acc, obj) => {
      const key = obj[property];
      if (!acc[key]) {
         acc[key] = [];
      }
      // Add object to list for given key's value
      acc[key].push(obj);
      return acc;
   }, {});
}

// console.log("issues",$issueChoices)


  function issueFilter(level){

    if (level=="city"){
      let cleaned = [];
      let filter = $issueChoices.filter(d=>{return d.level==level})
      let grouped = groupBy(filter, "issue");
      // console.log("grouped",grouped)
      for (const [key, value] of Object.entries(grouped)) {
        // console.log(key)
        let byCity = value.filter(v=>v.city == cityName )
        let allCity = value.filter(v=>v.city=='')
        let test=[...byCity,...allCity]
        // console.log(test)
        if (test[0] != undefined){
          cleaned.push (...test)
        }
      }

      return cleaned
    }else{
      //console.log("regular issue filter for", level)
      let c =  $issueChoices.filter(d=>{return d.level == level})
      return c
  
    }
      
  }
    
  $slidesTracker = {
    city: 0, 
    county: 0, 
    state: 0
  };

  // map
  onMount(() => {
    let ads = document.querySelector('aside.advertisement')
    ads.classList.remove('hidden');

    // set keyboard focus
    let firstFocus = document.querySelector('.issues-nav button');
    firstFocus.focus();
    firstFocus.blur();

    createMap(
      $geocoderResult.center,
      feed.locality.id,
      feed.county.id,
      feed.state.assembly.id,
      feed.state.state_senate.id,
      feed.federal.id
    );
    createAssemblySenateMap(
      $geocoderResult.center,
      feed.state.assembly.id,
      feed.state.state_senate.id,
    );

    // get photo of combo map
    let screenshotButton = document.querySelector('#map-screenshot');
    screenshotButton.addEventListener('click', function (e) {
      takeScreenshot();
    });

    let printButton = document.getElementById('print_button');
    printButton.addEventListener('click', function (e) {
      handlePrint();
 
    })

  });

  $: isCity =  $tileData['place'] == "Unincorporated" ? false : true;
  $: cityName = $tileData['place']

  let printDrawer = false;
  
  
  function handlePrint() {
		printDrawer = !printDrawer; 
	}
/// ZONES
function zonesFilter(level) {
    let tmp = [];
    let filteredList = $zonesChoices.filter(d=>{return d.zone.toLowerCase()==level});
    if (level == "city") {
      if (cityName == "Los Angeles") {
        tmp = (filteredList.filter(d=>{return d.city_filter == "los-angeles" }));
      } else if (isCity && cityName != "Los Angeles") {
        tmp = (filteredList.filter(d=>{return d.city_filter == "not-la"}));
      } else {
        // unincorporated
        tmp = (filteredList.filter(d=>{return d.city_filter == "unincorporated"}));
      }
    } else if (level == "county") {
      if (isCity) {
        tmp = (filteredList.filter(d=>{return d.city_filter == "all-cities" }));
      } else {
        tmp = (filteredList.filter(d=>{return d.city_filter == "unincorporated" }));
      }
    } else if ((level == "state") || (level == "federal")) {
      tmp = (filteredList);
    }

    // console.log('zones filter console log', tmp);
    let cleaned = {
      'heading': tmp[0].heading_html,
      'content': tmp[0].content_html,
      'heading_es': tmp[0].heading_es_html,
      'content_es': tmp[0].content_es_html
    }

    // console.log('zones filter CLEANED console log', cleaned);
    let regexClean = cleanRegex(cleaned, varDict);
    // console.log('REGEXCLEAN TEST', regexClean);

    return regexClean;
  }

  // the data that is pulled from the feed object is tied to
  let varDict = {
    '{city_name}': __(feed["locality"].id),
    '{city_name_url}': `<a target='_blank' href='${feed["locality"].url}'>${__(feed["locality"].id)}</a>`,
    '{council_member_count}': __(feed["locality"].member_count),
    '{with/and}': data.direct_elect == false ? __('with') : __('and'),
    '{mayor_election_cycle}': __(feed["locality"].mayorselect),
    "{city_name('s)}": (feed["locality"].id.charAt(feed["locality"].id.length - 1) == 's') ? `${__(feed["locality"].id)}&rsquo;`: `${feed["locality"].id}&rsquo;s`,
    "{supervisor_district}": `${__('District')} ${feed["county"].id}`,
    "{supervisor_district_number}": feed["county"].id,
    "{repname}": feed["county"].repname,
    "{assembly_district}": t(districtNames, 'assembly', {id: feed["state"].assembly.id}),
    "{senate_district}": t(districtNames, 'senate', {id: feed["state"].state_senate.id}),
    "{congressional_district}": t(districtNames, 'congressional', {id: feed["federal"].id})
  }

  function cleanRegex(content) {
    let headingText = content.heading;
    let contentText = content.content;
    let headingESText = content.heading_es;
    let contentESText = content.content_es;
    let re = /({.+?})/g;
    // first the heading
    const heading_matches = headingText.match(re);
    const content_matches = contentText.match(re);

    if (heading_matches) {
      heading_matches.forEach(function(o) {
        headingText = headingText.replace(String(o), varDict[String(o)]);
      });
    };
    if (content_matches) {
      content_matches.forEach(function(o) {
        contentText = contentText.replace(String(o), varDict[String(o)]);
      });
    };

    if (headingESText) {
      const headingES_matches = headingESText.match(re);
      if (headingES_matches) {
      headingES_matches.forEach(function(o) {
        headingESText = headingESText.replace(String(o), varDict[String(o)]);
      });
    };
    }

    if (contentESText) {
      const contentES_matches = contentESText.match(re);
      if (contentES_matches) {
      contentES_matches.forEach(function(o) {
        contentESText = contentESText.replace(String(o), varDict[String(o)]);
      });
    };
    }
    // if (headingES_matches) {
    //   headingES_matches.forEach(function(o) {
    //     headingESText = headingESText.replace(String(o), varDict[String(o)]);
    //   });
    // };
    // if (contentES_matches) {
    //   contentES_matches.forEach(function(o) {
    //     contentESText = contentESText.replace(String(o), varDict[String(o)]);
    //   });
    // };


    let cleanObj = {
      'heading': headingText,
      'content': contentText,
      'heading_es': headingESText,
      'content_es': contentESText
    };
    return cleanObj;
  }


</script>

<Loading></Loading>
<Alert/>

<Locality
  data = {feed["locality"]}
  issuesList = {issueFilter("city")}
  isCity = {isCity}
  zonesContent = {zonesFilter("city")}
/>
<County
  data = {feed["county"]}
  isCity = {isCity}
  cityName = {cityName}
  issuesList = {issueFilter("county")}
  zonesContent = {zonesFilter("county")}
/>
<State
  data = {feed["state"]}
  zonesContent = {zonesFilter("state")}
/>
<Federal
  data = {feed["federal"]}
  issuesList = {issueFilter("federal")}
  zonesContent = {zonesFilter("federal")}
/>

<Bottom
  feed = {feed}
/>

{#if printDrawer}
  <Print on:printDrawer={handlePrint}/>
{/if}